class SizeGuideTabs extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.tabButtons = this.querySelectorAll(".size-guide-tab");
    this.tabContents = this.querySelectorAll(".size-guide-content");

    this.tabButtons.forEach((button, index) => {
      button.addEventListener("click", () => this.switchTab(index));
    });
  }

  switchTab(activeIndex) {
    // Remove active class from all tabs and contents
    this.tabButtons.forEach((button) => button.classList.remove("active"));
    this.tabContents.forEach((content) => content.classList.remove("active"));

    // Add active class to clicked tab and corresponding content
    this.tabButtons[activeIndex].classList.add("active");
    if (this.tabContents[activeIndex]) {
      this.tabContents[activeIndex].classList.add("active");
    }
  }
}

customElements.define("size-guide-tabs", SizeGuideTabs);
